<div [formGroup]="reportForm">
  <div>
    <mat-form-field>
      <mat-label>Choose a start date</mat-label>
      <input formControlName="startDate" matInput [matDatepicker]="startPicker">
      <mat-hint>YYYY-MM-dd</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>     
  </div>
  <div>
    <mat-form-field>
      <mat-label>Choose a end date</mat-label>
      <input formControlName="endDate" matInput [matDatepicker]="endPicker">
      <mat-hint>YYYY-MM-dd </mat-hint>
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>     
  </div>
</div>
<div>
  <button mat-raised-button (click)="getCSV()" class="button">
    Get CSV
  </button>
</div>
<br>
<mat-expansion-panel [expanded]="false">
  <mat-expansion-panel-header>
      <mat-panel-title>Output</mat-panel-title>
      <mat-panel-description>
          JSON
      </mat-panel-description>
  </mat-expansion-panel-header>
  <pre>{{ reportData | json }}</pre>
</mat-expansion-panel>